module.exports = require('./helpers/bundle-url').getBundleURL('i3X7Z') + "logo.7718c6df.svg";